/** 図形の四角へ適用する、ステージ座標上の角丸半径。 */
export const SHAPE_RECT_CORNER_RADIUS_PX = 4;

/**
 * 四角の寸法と描画スケールに応じた角丸半径を返す。
 * 極小サイズでは辺の半分までに抑え、潰れた寸法では 0 にする。
 */
export function resolveRectCornerRadius(w: number, h: number, scale = 1): number {
  const base = SHAPE_RECT_CORNER_RADIUS_PX * scale;
  return Math.max(0, Math.min(base, w / 2, h / 2));
}

/**
 * 角丸矩形のパスを現在のパスへ追加する。beginPath は呼び出し側で行う。
 * roundRect が使えない環境では arcTo、さらに arcTo も無い環境では直角の矩形へ退避する。
 */
export function traceRoundedRectPath(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  radius: number
): void {
  if (typeof ctx.roundRect === "function") {
    ctx.roundRect(x, y, w, h, radius);
    return;
  }

  if (typeof ctx.arcTo !== "function") {
    ctx.rect(x, y, w, h);
    return;
  }

  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + w - radius, y);
  ctx.arcTo(x + w, y, x + w, y + radius, radius);
  ctx.lineTo(x + w, y + h - radius);
  ctx.arcTo(x + w, y + h, x + w - radius, y + h, radius);
  ctx.lineTo(x + radius, y + h);
  ctx.arcTo(x, y + h, x, y + h - radius, radius);
  ctx.lineTo(x, y + radius);
  ctx.arcTo(x, y, x + radius, y, radius);
  ctx.closePath();
}
